import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const name = 'chatFrameSlice';

interface ChatFrameState {
    activeContent: string;
    isResetDialogOpen: boolean;
    isFullscreen: boolean;
    promptBoxValue: string;
    paddingHeight: number;
    errorMessage?: string;
    focusPromptBox: () => void;
    panelWidth: number;
    isPanelOpen: boolean;
    cachedChatScrollPosition: number;
    hasRecentPromptsStyling: boolean;
}

const initialState = {
    activeContent: 'login',
    isResetDialogOpen: false,
    isFullscreen: false,
    focusPromptBox: null,
    promptBoxValue: '',
    errorMessage: null,
    paddingHeight: 0,
    panelWidth: 0,
    isPanelOpen: false,
    cachedChatScrollPosition: 0,
    hasRecentPromptsStyling: false,
};

const openResetDialog = (state: ChatFrameState) => {
    state.isResetDialogOpen = true;
};

const closeResetDialog = (state: ChatFrameState) => {
    state.isResetDialogOpen = false;
};

const openPanel = (state: ChatFrameState) => {
    state.isPanelOpen = true;
};

const closePanel = (state: ChatFrameState) => {
    state.isPanelOpen = false;
};

const focusPromptBox = (
    state: ChatFrameState,
    action: PayloadAction<() => void>
) => {
    state.focusPromptBox = action.payload;
};

const setIsFullscreen = (
    state: ChatFrameState,
    action: PayloadAction<boolean>
) => {
    state.isFullscreen = action.payload;
};

const setPaddingHeight = (
    state: ChatFrameState,
    action: PayloadAction<number>
) => {
    state.paddingHeight = action.payload;
};

const setHasRecentPromptsStyling = (
    state: ChatFrameState,
    action: PayloadAction<boolean>
) => {
    state.hasRecentPromptsStyling = action.payload;
};
const setActiveContent = (
    state: ChatFrameState,
    action: PayloadAction<string>
) => {
    state.activeContent = action.payload;
};

const setCachedChatScrollPosition = (
    state: ChatFrameState,
    action: PayloadAction<number>
) => {
    state.cachedChatScrollPosition = action.payload;
};

const setErrorMessage = (
    state: ChatFrameState,
    action: PayloadAction<string>
) => {
    state.errorMessage = action.payload ? action.payload : null;

    state.activeContent = action.payload ? 'error' : 'chat';
};

const setIsResetDialogOpen = (
    state: ChatFrameState,
    action: PayloadAction<boolean>
) => {
    state.isResetDialogOpen = action.payload;
};

const setPanelWidth = (
    state: ChatFrameState,
    action: PayloadAction<number>
) => {
    state.panelWidth = action.payload;
};

/**
 * Slice for managing the chat state.
 */
const reducers = {
    setCachedChatScrollPosition,
    openResetDialog,
    closeResetDialog,
    setIsFullscreen,
    setPaddingHeight,
    setActiveContent,
    setHasRecentPromptsStyling,
    focusPromptBox,
    setErrorMessage,
    setIsResetDialogOpen,
    setPanelWidth,
    openPanel,
    closePanel,
};

/**
 * A Redux slice for states of ChatBLK app components.
 */
const chatFrameSlice = createSlice({
    name,
    initialState,
    reducers,
});
export const chatFrameActions = chatFrameSlice.actions;
export default chatFrameSlice;
